<template>
  <div id="activity-settings">
    <mu-card-header
      titleClass="boldTitle largeTitle"
      :title="title"
      :subTitle="subTitle"
    ></mu-card-header>
    <mu-card-text>
      <mu-flexbox-item align="center" v-if="isLoading">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
      <div class="table">
        <mu-table :showCheckbox="false" v-if="!isLoading">
          <mu-thead>
            <mu-th v-text="$t('message.settingsActivityHeadingDevice')"></mu-th>
            <!--<mu-th v-text="$t('message.settingsActivityHeadingEngine')"></mu-th>-->
            <mu-th v-text="$t('message.settingsActivityHeadingOS')"></mu-th>
            <mu-th v-text="$t('message.settingsActivityHeadingIp')"></mu-th>
            <mu-th v-text="$t('message.settingsActivityHeadingDate')"></mu-th>
          </mu-thead>
          <mu-tbody>
            <mu-tr v-for="login, index in logins" :key="`login-${index}`">
              <mu-td v-text="login.device || '-'"></mu-td>
              <!--<mu-td v-text="login.engine"></mu-td>-->
              <mu-td v-text="login.os"></mu-td>
              <mu-td>{{login.ip_address.replace(', 35.244.130.1', ' ')}}</mu-td>
              <mu-td v-text="formatDate(login.date_created)"></mu-td>
            </mu-tr>
          </mu-tbody>
        </mu-table>
      </div>
      <div class="suspicious">
        <p>Notice anything suspicious? <router-link :to="{name: 'Contact'}">Contact us</router-link>.</p>
      </div>
    </mu-card-text>
  </div>
</template>
<script>

  import UserApi from '../../api/User'



  export default {
    data() {
      return {
        title: this.$t('message.activitySettingsTitle'),
        subTitle: this.$t('message.activitySettingsSubTitle'),
        logins: [],
        isLoading: true,
      }
    },
    methods: {
      initMounted() {
        let self = this;
        self.getTrackings();
      },
      getTrackings() {
        let self = this;
        self.isLoading = true;
        UserApi.getLoginTrackings().then(response => {
          self.logins = response.data;
          self.isLoading = false;
        });
      },
      formatDate(date) {
        return moment(date).format('MMMM Do YYYY, h:mm a');
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }
</script>
<style lang="less">
  #activity-settings {
    .table {
      margin: 0 0 16px;
      border-bottom: 1px solid #DADBDF;
      overflow: auto;
    }
    .mu-table {
      width: 790px;
      background-color: rgba(241, 241, 242, 0.85);
      .mu-tr {
        background-color: #FFF;
        border-color: rgba(212, 213, 218, 0.85);
      }
      .mu-th {
        color: #2E2E32;
        font-size: 13px;
        font-weight: 500;
      }
      .mu-td {
        padding: 16px 24px;
        white-space: normal;
      }
    }
    .suspicious {
      p {
        margin-bottom: 5px;
        font-size: 14px;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Activity.vue?234de2e1